<template>
  <div>
    <main-layout>
      <v-container>
        <h1>{{ $t('Main page') }}</h1>
        <img
          class="mt-1"
          src="/static/img/assets/loading/z-07.png"
          alt
          style="width: 80px; float: left; margin-right: 20px;"
        />
        <div>
          <p class="mb-1 mt-3">
            {{ $t('Nong C will become your page assistant in using ZWIZ.') }}
          </p>
          <p class="mb-5">
            {{ $t('Nong C would like to help you complete the setup as much as possible.') }}
          </p>
        </div>
        <template>
          <v-item-group v-model="select">
            <!-- <v-container grid-list-md> -->
            <v-flex xs12>
              <v-layout row wrap>
                <template v-for="(item, n) in menu">
                  <v-flex xs12 sm4 class="mt-2 px-2" :key="n">
                    <v-item>
                      <v-card
                        slot-scope="{ active, toggle }"
                        :class="active ? 'bg-active' : ''"
                        height="80"
                        style="display: grid; border-radius: 17px 17px 17px 0px; "
                        @click="toggle"
                      >
                        <v-scroll-y-transition>
                          <div
                            @click="
                              item.icon === 'fas fa-wrench' ? countClickPlatformUpdate('00') : ''
                            "
                            style="font-size: 16px; font-weight: bold; padding: 18px 14px;"
                            :class="active ? 'primary--text' : ''"
                          >
                            <i
                              :style="n == 0 ? 'padding: 9px 13px;' : ''"
                              style="width: 45px;"
                              class="icon-set mr-2"
                              :class="active ? `icon-active ${item.icon}` : item.icon"
                            ></i>
                            {{ item.label }}
                          </div>
                        </v-scroll-y-transition>
                      </v-card>
                    </v-item>
                  </v-flex>
                </template>
              </v-layout>
            </v-flex>
          </v-item-group>
        </template>

        <div class="mt-5">
          <div v-if="checkLists.length === 0" class="spinner text-xs-center">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
          <div
            v-if="select === 0 && checkLists.length > 0"
            style="padding: 30px; background: #fff; border-radius: 30px;"
          >
            <h2>{{ $t('Check list settings') }}</h2>
            <span>
              {{ $t('Completing the main steps below will help you set up completely.') }}</span
            >
            <v-divider class="mt-2" style="border-color: #CF005C" />
            <v-progress-linear
              color="#CCCCCC"
              style="border-radius: 15px;"
              class="text-xs-center"
              v-model="progress"
              height="25"
            >
              <strong style="font-size: 18px; color: #000;">{{ progress.toFixed(2) }}%</strong>
            </v-progress-linear>

            <template v-for="(checkList, index) in checkLists">
              <v-layout style="    height: 65px;" :key="index">
                <v-flex xs2 sm1>
                  <v-checkbox color="primary" class="disabled" v-model="checkList.checkbox">
                  </v-checkbox>
                </v-flex>
                <v-flex xs11 style="align-self: center;">
                  <h3
                    class="d-inline-block black--text"
                    style="cursor: pointer;"
                    @click="
                      $router.push({
                        path: checkList.link
                      })
                    "
                  >
                    {{ $t(checkList.name) }} {{ checkList.count || '' }}
                  </h3>
                  <a
                    v-if="checkList.url"
                    :href="checkList.url"
                    target="blank"
                    class="ml-1"
                    style="align-self: center; margin-bottom: 3px;"
                    >{{ $t('how_to_set') }}</a
                  >
                  <template v-else>
                    <a
                      @click="
                        dialog = true
                        image = checkList.image
                      "
                      target="blank"
                      class="ml-1"
                      style="align-self: center; margin-bottom: 3px;"
                      >{{ $t('how_to_set') }}</a
                    >
                  </template>
                </v-flex>
              </v-layout>
            </template>
            <v-dialog v-model="dialog" width="1200">
              <v-card>
                <div class="text-xs-right">
                  <v-btn color="primary" fab small flat @click="dialog = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
                <v-card-text>
                  <img style="width: 100%;" :src="image" />
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <div
            v-else-if="select === 1"
            style="padding: 30px; background: #fff; border-radius: 30px;"
          >
            <h2>
              {{ $t('Tutorials') }}
              <a href="https://blog.zwiz.app/" target="blank"
                ><i style="font-size: 18px; color: #ed1e79;" class="fas fa-question-circle"></i
              ></a>
            </h2>
            <v-divider class="mt-2 mb-4" style="border-color: #CF005C" />
            <v-layout row wrap>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/y9dyykv7"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('Add/Change Chatbot Page') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/z9z63ztb "
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('Welcome Message') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/3758bkbm"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('Conversation') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/yvz76f5s"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('Reply to comment') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/5aj2ksc4"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('Training') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/yhfh6fd7"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('Analytics') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/y27chwmw"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('Broadcast') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://blog.zwiz.app/tutorial-6-shopservice/"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('shopservice') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/y8kv4k9h"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('Shop Salepage') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/2vbz8zsy"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('Coupon') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/mrxa5m58"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('live') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/yc39vjwe"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('Add to cart') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/taynws5p"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('Connect Shippop') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://blog.zwiz.app/lineoachatbot/"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('Connect LINE') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/2p82ydvv"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('Line Notifys') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 md4 lg3 xl2>
                <v-btn
                  outline
                  href="https://tinyurl.com/3pbbzz54"
                  target="blank"
                  color="primary"
                  class="home-btn"
                  style="width: 93%; padding: 30px; font-size: 17px;"
                  >{{ $t('CONTEXT CONVERSATION') }}</v-btn
                >
              </v-flex>
            </v-layout>
          </div>
          <div
            v-else-if="select === 2"
            style="padding: 30px; background: #fff; border-radius: 30px;"
          >
            <h2>{{ $t('ZWIZ.AI Platform Change Log') }}</h2>
            <v-divider class="mt-2" style="border-color: #CF005C" />
            <platform-update @countClickPlatformUpdate="countClickPlatformUpdate"></platform-update>
          </div>
        </div>
        <v-dialog persistent v-model="dialogSalepage" max-width="500px">
          <v-card>
            <div style="position: absolute; right: 5px; top: 5px; z-index: 25;">
              <v-btn color="primary" fab small flat @click="closeDailog">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <v-card-title style="display:flow-root; padding: 8px;">
              <v-carousel hide-delimiters>
                <template v-for="(item, i) in bannerCarousels">
                  <v-carousel-item
                    :key="i"
                    style="cursor:pointer; background-size: contain"
                    :src="item.src"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                    @click.stop="openDetailDialog(item.url)"
                  ></v-carousel-item>
                </template>
              </v-carousel>

              <v-checkbox
                style="float: left;"
                v-model="checkbox"
                color="primary"
                class="mt-3"
                :label="`ไม่ต้องแสดงหน้านี้อีก`"
              ></v-checkbox>
              <v-btn style="float: right;" outline color="primary" @click="closeDailog">
                {{ $t('close') }}
              </v-btn>
            </v-card-title>
          </v-card>
        </v-dialog>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import PlatformUpdate from '@/components/view/platformupdate/PlatformUpdate.vue'
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  components: {
    PlatformUpdate
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  data() {
    return {
      dialogSalepage: false,
      checkbox: false,
      dialog: false,
      select: 0,
      menu: [
        { label: this.$t('Check list settings'), icon: 'fas fa-clipboard-list' },
        { label: this.$t('Tutorials'), icon: 'fas fa-book-open' },
        { label: this.$t('Platform Update'), icon: 'fas fa-wrench' }
      ],
      checkLists: [],
      progress: 0,
      image: null,
      bannerCarousels: [
        // {
        //   src: '/static/img/assets/richmenu-lifetime-banner.jpeg',
        //   url: 'https://m.me/361231620965547?ref=RichMenucampaign_popup'
        // },
        {
          src: '/static/img/assets/richmenu_banner.jpg',
          url: 'https://m.me/361231620965547?ref=designrichmenu_popup '
        },  
        {
          src: '/static/img/assets/GPTplusBeta.jpg',
          url: 'https://m.me/361231620965547?ref=chatgpt-plus'
        },
        {
          src: '/static/img/assets/bannersso.jpg',
          url: 'https://zwiz.app/'
        },
        {
          src: '/static/img/assets/banner5feture.jpg',
          url:
            'https://www.facebook.com/zwizai/posts/pfbid0mQJVkW9DMgiRUaELBrSqAH57w2ew1KRnCae6XhGtQ8V5NcgsNTWFdo6AZVTGXbMil/?utm_source=popup'
        }
      ]
    }
  },
  mounted() {
    const vm = this
    vm.$store.dispatch('updateBotDetail')
    if (localStorage.getItem('dialogSalepage') == null) {
      vm.dialogSalepage = true
    } else {
      vm.dialogSalepage = JSON.parse(localStorage.getItem('dialogSalepage'))
    }

    window.scrollTo(0, 0)
    if (
      ['111', '112', '113', '114', '115'].includes(this.selectedBot.selected_presets) ||
      ['111', '112', '113', '114', '115'].includes(this.$route.query.preset)
    ) {
      this.getCheckList()
    } else {
      this.welcomeChecklist()
    }
    if (
      this.$route.query &&
      this.$route.query.page &&
      this.$route.query.page === 'platformupdate'
    ) {
      this.select = 2
    }
    if (this.$route.query.gbRef) {
      this.checkTokenGbPayment(this.$route.query.gbRef)
    }
  },
  methods: {
    async countClickPlatformUpdate(id) {
      const vm = this
      vm.post(`page/${vm.$store.state.selectedBot.pageid}/cms-platform-update-click`, {
        field_id: id
      })
    },
    setGtagCloseBanner() {
      const vm = this
      const prefix = ['cms.zwiz.app', 'cms.zwiz.ai'].includes(window.location.hostname) ? 'z_' : ''
      vm.$gtag.event(`${prefix}close_banner`, { event_category: vm.selectedBot.pageid })
    },
    openDetailDialog(url) {
      window.open(url, '_blank')
    },
    closeDailog() {
      const vm = this
      localStorage.setItem('dialogSalepage', !vm.checkbox)
      vm.dialogSalepage = false
      if (vm.checkbox) {
        vm.setGtagCloseBanner()
      }
    },
    async checkTokenGbPayment(gbRef) {
      var data = {
        pageid: this.selectedBot.pageid,
        body: {
          card_token: gbRef
        }
      }
      try {
        var vm = this
        var { result } = await api.checkTokenStatus(data)
        if (result.resultCode === '00') {
          vm.$swal
            .fire({
              title: vm.$t('payment_successful'),
              text: vm.$t('setup_guide'),
              type: 'success',
              confirmButtonText: vm.$t('read_tutorial'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true,
              showCancelButton: true,
              footer: vm.$t('if_you_want_any_help_text'),
              html:
                result.detail.includes('12month_extra_advanced_fb') ||
                result.detail.includes('12month_extra_fb')
                  ? `<div>${vm.$t('qrLineNote')}</div><img src="/static/img/qr-line.png"></img>`
                  : ''
            })
            .then(result => {
              if (result.value) {
                window.open(
                  'https://blog.zwiz.app/',
                  '_blank',
                  'toolbar=yes,scrollbars=yes,resizable=yes,top=0,width=1000,height=900'
                )
              }
            })
        } else {
          vm.$swal.fire({
            title: vm.$t('payment_unsuccessful'),
            text: vm.errorMessage,
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true,
            footer: vm.$t('if_you_want_any_help_text')
          })
        }
      } catch (e) {
        vm.$swal.fire({
          title: vm.$t('payment_unsuccessful'),
          text: vm.errorMessage,
          type: 'error',
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
          footer: vm.$t('if_you_want_any_help_text')
        })
      }
      vm.$router.replace({ query: null })
    },
    async welcomeChecklist() {
      try {
        var { result } = await api.welcomeChecklist(this.selectedBot.pageid)
        if (result) {
          delete result.has_salepage
          delete result.has_salepage_pixel
          delete result.has_promo_code
          delete result.has_shipping
          this.checkLists = [
            {
              checkbox: result.has_welcome_message,
              link: `/${
                this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
              }/chatbot?tab=WelcomeMessage`,
              url: 'https://tinyurl.com/z9z63ztb',
              name: 'Welcome Message'
            },
            {
              checkbox: result.has_inbox_intent,
              link: `/${
                this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
              }/chatbot?tab=Conversation`,
              url: 'https://tinyurl.com/3758bkbm',
              name: 'Conversation'
            },
            {
              checkbox: result.has_comment_intent,
              link: `/${
                this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
              }/chatbot?tab=Comment`,
              url: 'https://tinyurl.com/yvz76f5s',
              name: 'Reply Comment'
            },
            {
              checkbox: result.has_product,
              link: `/${
                this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
              }/template?tab=Products`,
              url: 'https://blog.zwiz.app/tutorial-6-shopservice/',
              name: 'Add Product(s)'
            },
            {
              checkbox: result.has_payment,
              link: `/${
                this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
              }/template?tab=mainPayment`,
              url: 'https://tinyurl.com/4trrbhje',
              name: 'Payments'
            },
            {
              checkbox: result.has_shop_address,
              link: `/${
                this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
              }/template?tab=ShippingMethod`,
              url: 'https://blog.zwiz.app/tutorial-6-shopservice/',
              name: 'Shipping Methods'
            }
          ]
          var p = 100 / this.checkLists.length
          this.progress = 0
          this.checkLists.map(checkList => {
            if (checkList.checkbox) {
              this.progress += p
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getCheckList() {
      try {
        let data = {
          pageid: this.selectedBot.pageid,
          params: {
            selected_presets: this.selectedBot.selected_presets || this.$route.query.preset
          }
        }
        let { result } = await api.getCheckList(data)
        if (result) {
          let countCate = 0
          if (result.category_conversation_setup_1) {
            countCate = countCate + 1
          }
          if (result.category_conversation_setup_2) {
            countCate = countCate + 1
          }
          if (result.category_conversation_setup_3) {
            countCate = countCate + 1
          }

          let countProduct = 0
          if (result.product_detail_conversation_setup_1) {
            countProduct = countProduct + 1
          }
          if (result.product_detail_conversation_setup_2) {
            countProduct = countProduct + 1
          }
          if (result.product_detail_conversation_setup_3) {
            countProduct = countProduct + 1
          }

          let countCateShop = 0
          if (result.category_shop_setup_1) {
            countCateShop = countCateShop + 1
          }
          if (result.category_shop_setup_2) {
            countCateShop = countCateShop + 1
          }
          if (result.category_shop_setup_3) {
            countCateShop = countCateShop + 1
          }

          let countProdShop = 0
          if (result.product_shop_setup_1 && countProdShop < 3) {
            countProdShop = countProdShop + 1
          }
          if (result.product_shop_setup_2 && countProdShop < 3) {
            countProdShop = countProdShop + 1
          }
          if (result.product_shop_setup_3 && countProdShop < 3) {
            countProdShop = countProdShop + 1
          }
          if (result.product_shop_setup_4 && countProdShop < 3) {
            countProdShop = countProdShop + 1
          }
          if (result.product_shop_setup_5 && countProdShop < 3) {
            countProdShop = countProdShop + 1
          }
          if (result.product_shop_setup_6 && countProdShop < 3) {
            countProdShop = countProdShop + 1
          }
          if (result.product_shop_setup_7 && countProdShop < 3) {
            countProdShop = countProdShop + 1
          }
          if (result.product_shop_setup_8 && countProdShop < 3) {
            countProdShop = countProdShop + 1
          }
          if (result.product_shop_setup_9 && countProdShop < 3) {
            countProdShop = countProdShop + 1
          }

          let countCouponReplyComment = 0
          if (result.coupon_reply_comment_setup_1) {
            countCouponReplyComment = countCouponReplyComment + 1
          }
          if (result.coupon_reply_comment_setup_2) {
            countCouponReplyComment = countCouponReplyComment + 1
          }
          if (result.coupon_reply_comment_setup_3) {
            countCouponReplyComment = countCouponReplyComment + 1
          }

          let countPromotionDetailConversation = 0
          if (result.promotion_detail_conversation_setup_1) {
            countPromotionDetailConversation = countPromotionDetailConversation + 1
          }
          if (result.promotion_detail_conversation_setup_2) {
            countPromotionDetailConversation = countPromotionDetailConversation + 1
          }
          if (result.promotion_detail_conversation_setup_3) {
            countPromotionDetailConversation = countPromotionDetailConversation + 1
          }

          let countCollectCouponConversation = 0
          if (result.collect_coupon_conversation_setup_1) {
            countCollectCouponConversation = countCollectCouponConversation + 1
          }
          if (result.collect_coupon_conversation_setup_2) {
            countCollectCouponConversation = countCollectCouponConversation + 1
          }
          if (result.collect_coupon_conversation_setup_3) {
            countCollectCouponConversation = countCollectCouponConversation + 1
          }

          if (this.selectedBot.selected_presets === '112') {
            this.checkLists = [
              {
                checkbox: result.welcome_message_setup,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=WelcomeMessage`,
                image: `/static/img/assets/preset/how-to/2/${this.currentLang}/1.PNG`,
                name: 'welcome_message_setup'
              },
              {
                checkbox: result.browse_products_conversation_setup,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=Conversation`,
                image: `/static/img/assets/preset/how-to/2/${this.currentLang}/2.PNG`,
                name: 'browse_products_conversation_setup'
              },
              {
                checkbox: countCate === 3,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=Conversation`,
                image: `/static/img/assets/preset/how-to/2/${this.currentLang}/3.PNG`,
                name: 'category_conversation_setup',
                count: `(${countCate}/3)`
              },
              {
                checkbox: countProduct === 3,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=Conversation`,
                image: `/static/img/assets/preset/how-to/2/${this.currentLang}/4.PNG`,
                name: 'product_detail_conversation_setup',
                count: `(${countProduct}/3)`
              },
              {
                checkbox: result.promotion_conversation_setup,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=Conversation`,
                image: `/static/img/assets/preset/how-to/2/${this.currentLang}/5.PNG`,
                name: 'promotion_conversation_setup'
              },
              {
                checkbox: result.active_bot,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/billing`,
                image: `/static/img/assets/preset/how-to/2/${this.currentLang}/6.PNG`,
                name: 'active_bot'
              }
            ]
          } else if (this.selectedBot.selected_presets === '111') {
            this.checkLists = [
              {
                checkbox: result.welcome_message_setup,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=WelcomeMessage`,
                image: `/static/img/assets/preset/how-to/1/${this.currentLang}/1.PNG`,
                name: 'welcome_message_setup'
              },
              {
                checkbox: result.promotion_conversation_setup,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=Conversation`,
                image: `/static/img/assets/preset/how-to/1/${this.currentLang}/2.PNG`,
                name: 'promotion_conversation_setup'
              },
              {
                checkbox: countPromotionDetailConversation,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=Conversation`,
                image: `/static/img/assets/preset/how-to/1/${this.currentLang}/3.PNG`,
                name: 'promotion_detail_conversation_setup',
                count: `(${countPromotionDetailConversation}/3)`
              },
              {
                checkbox: countCollectCouponConversation,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=Conversation`,
                image: `/static/img/assets/preset/how-to/1/${this.currentLang}/4.PNG`,
                name: 'collect_coupon_conversation_setup',
                count: `(${countCollectCouponConversation}/3)`
              },
              {
                checkbox: result.secret_code_conversation_setup,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=Conversation`,
                image: `/static/img/assets/preset/how-to/1/${this.currentLang}/5.PNG`,
                name: 'secret_code_conversation_setup'
              },
              {
                checkbox: countCouponReplyComment,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=Comment`,
                image: `/static/img/assets/preset/how-to/1/${this.currentLang}/6.PNG`,
                name: 'coupon_reply_comment_setup',
                count: `(${countCouponReplyComment}/3)`
              },
              {
                checkbox: result.active_bot,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/billing`,
                image: `/static/img/assets/preset/how-to/1/${this.currentLang}/7.PNG`,
                name: 'active_bot'
              }
            ]
          } else if (this.selectedBot.selected_presets === '113') {
            this.checkLists = [
              {
                checkbox: result.welcome_message_setup,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=WelcomeMessage`,
                image: `/static/img/assets/preset/how-to/3/${this.currentLang}/1.PNG`,
                name: 'welcome_message_setup'
              },
              {
                checkbox: result.browse_products_conversation_setup,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=Conversation`,
                image: `/static/img/assets/preset/how-to/3/${this.currentLang}/2.PNG`,
                name: 'browse_products_conversation_setup'
              },
              {
                checkbox: countCateShop === 3,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/template?tab=Products`,
                image: `/static/img/assets/preset/how-to/3/${this.currentLang}/3.PNG`,
                name: 'category_shop_setup',
                count: `(${countCateShop}/3)`
              },
              {
                checkbox: countProdShop === 3,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/template?tab=Products`,
                image: `/static/img/assets/preset/how-to/3/${this.currentLang}/4.PNG`,
                name: 'product_shop_setup',
                count: `(${countProdShop}/3)`
              },
              {
                checkbox: countCate === 3,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=Conversation`,
                image: `/static/img/assets/preset/how-to/3/${this.currentLang}/5.PNG`,
                name: 'category_conversation_setup',
                count: `(${countCate}/3)`
              },
              {
                checkbox: countProduct === 3,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=Conversation`,
                image: `/static/img/assets/preset/how-to/3/${this.currentLang}/6.PNG`,
                name: 'product_detail_conversation_setup',
                count: `(${countProduct}/3)`
              },
              {
                checkbox: result.payment_setup,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/template?tab=Payment`,
                image: `/static/img/assets/preset/how-to/3/${this.currentLang}/7.PNG`,
                name: 'payment_setup'
              },
              {
                checkbox: result.shipping_setup,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/template?tab=ShippingMethod`,
                image: `/static/img/assets/preset/how-to/3/${this.currentLang}/8.PNG`,
                name: 'shipping_setup'
              },
              {
                checkbox: result.active_bot,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/billing`,
                image: `/static/img/assets/preset/how-to/3/${this.currentLang}/9.PNG`,
                name: 'active_bot'
              }
            ]
          } else if (
            this.selectedBot.selected_presets === '114' ||
            this.$route.query.preset === '114'
          ) {
            this.checkLists = [
              {
                checkbox: result.welcome_message_setup,
                link: `/${
                  this.$store.state && this.$store.state.lang ? $store.state.lang : 'th'
                }/chatbot?tab=WelcomeMessage`,
                image: `/static/img/assets/preset/how-to/4/${this.currentLang}/1.PNG`,
                name: 'welcome_message_setup'
              },
              {
                checkbox: result.general_conversation_setup,
                link: '',
                image: `/static/img/assets/preset/how-to/4/${this.currentLang}/2.PNG`,
                name: 'general_conversation_setup'
              },
              {
                checkbox: result.count_lead_generation_context
                  ? parseInt(result.count_lead_generation_context)
                  : 0 > 5,
                link: '',
                image: `/static/img/assets/preset/how-to/4/${this.currentLang}/3.PNG`,
                name: 'count_lead_generation_context',
                count: `(${result.count_lead_generation_context}/5)`
              },
              {
                checkbox: result.reply_comment_setup,
                link: '',
                image: `/static/img/assets/preset/how-to/4/${this.currentLang}/4.PNG`,
                name: 'reply_comment_setup'
              },
              {
                checkbox: result.connect_reply_comment_with_post_setup,
                link: '',
                image: `/static/img/assets/preset/how-to/4/${this.currentLang}/5.PNG`,
                name: 'connect_reply_comment_with_post_setup'
              },
              {
                checkbox: result.active_bot,
                link: '',
                image: `/static/img/assets/preset/how-to/4/${this.currentLang}/6.PNG`,
                name: 'active_bot'
              }
            ]
          } else if (
            this.selectedBot.selected_presets === '115' ||
            this.$route.query.preset === '115'
          ) {
            this.checkLists = [
              {
                checkbox: result.welcome_message_setup,
                link: '',
                image: `/static/img/assets/preset/how-to/5/${this.currentLang}/1.PNG`,
                name: 'welcome_message_setup'
              },
              {
                checkbox: result.general_conversation_setup,
                link: '',
                image: `/static/img/assets/preset/how-to/5/${this.currentLang}/2.PNG`,
                name: 'general_conversation_setup'
              },
              {
                checkbox: result.count_reservation_context
                  ? parseInt(result.count_reservation_context)
                  : 0 > 5,
                link: '',
                image: `/static/img/assets/preset/how-to/5/${this.currentLang}/3.PNG`,
                name: 'count_reservation_context',
                count: `(${result.count_reservation_context}/5)`
              },
              {
                checkbox: result.plug_in_google_calendar_setup,
                link: '',
                image: `/static/img/assets/preset/how-to/5/${this.currentLang}/4.PNG`,
                name: 'plug_in_google_calendar_setup'
              },
              {
                checkbox: result.working_hour_setup,
                link: '',
                image: `/static/img/assets/preset/how-to/5/${this.currentLang}/5.PNG`,
                name: 'working_hour_setup'
              },
              {
                checkbox: result.reservation_slot_setup,
                link: '',
                image: `/static/img/assets/preset/how-to/5/${this.currentLang}/6.PNG`,
                name: 'reservation_slot_setup'
              },
              {
                checkbox: result.active_bot,
                link: '',
                image: `/static/img/assets/preset/how-to/5/${this.currentLang}/7.PNG`,
                name: 'active_bot'
              }
            ]
          }
          var p = 100 / this.checkLists.length
          this.progress = 0
          this.checkLists.map(checkList => {
            if (checkList.checkbox) {
              this.progress += p
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
}
.bg-active {
  background: #fadae5;
}

.icon-active {
  background: #ff0059 !important;
  color: #fff !important;
}

.icon-set {
  padding: 9px;
  font-size: 25px;
  background: #f1f1f1;
  border-radius: 13px;
  color: #cbcbcb;
}
</style>



// WEBPACK FOOTER //
// src/components/view/home/Home.vue